"use client";

import { Button, type ButtonProps } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { useFullPageRedirect } from "@/hooks/use-full-page-redirect";

export function ShopifyReconnectButton({
  shopDomain,
  variant = "default",
  size = "default",
}: {
  shopDomain: string;
  variant?: ButtonProps["variant"];
  size?: ButtonProps["size"];
}) {
  const { isRedirecting: isReconnecting, redirect } = useFullPageRedirect();

  const url = `${process.env.JURNI_API_URL}/api/shopify/reconnect?shop=${encodeURIComponent(shopDomain)}`;
  return (
    <Button
      type="button"
      variant={variant}
      size={size}
      disabled={isReconnecting}
      aria-busy={isReconnecting}
      onClick={() => redirect(url)}
    >
      {isReconnecting && (
        <Loader2 className="mr-2 size-4 animate-spin" aria-hidden="true" />
      )}
      Reconnect Shopify
    </Button>
  );
}
